import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

export default function ShortLinkPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/annonces/s/${token}`)
      .then(res => navigate('/annonces', { state: { openAnnonceId: res.data.id }, replace: true }))
      .catch(() => navigate('/annonces', { replace: true }));
  }, [token, navigate]);

  return null;
}
